import { DomainSessionId, UserId } from '@hc-frontend/core-types';
import { z } from 'zod';

const LeadProductType = z.enum(['health', 'medicare']);
export const LeadProductRequestDto = z.object({
  domain_session_id: DomainSessionId.optional(),
  user_id: UserId,
  current_product_type: LeadProductType,
  new_product_type: LeadProductType,
});

// eslint-disable-next-line no-redeclare
export type LeadProductRequestDto = z.infer<typeof LeadProductRequestDto>;
